import React, { useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";

import { Helmet } from "react-helmet";

import withLoginOtpHash from "../../../../../hocs/withLoginOtpHash";
import { useLoginOtpHashLogin } from "../../../../../hooks/useLoginOtpHashLogin";
import AuthPageLayout from "../../../auth/AuthPageLayout";
import InvisibleReCaptcha from "../../../common/InvisibleReCaptcha";
import Loader from "../../../common/Loader";

function LoginOtpHash({
  hash,
  fromRegister = false,
  userData,
  loginHref,
  translate,
  verifyLoading,
  verifyOtpHash
}) {
  const history = useHistory();
  const reCaptchaRef = useRef(null);

  const runRecaptcha = useCallback(
    () => reCaptchaRef.current?.executeAsync?.(),
    []
  );

  const onRecaptchaFailure = useCallback(() => {
    history.push(loginHref);
  }, [history, loginHref]);

  const onVerifyFailure = useCallback(() => {
    history.push(loginHref);
  }, [history, loginHref]);

  useLoginOtpHashLogin({
    hash,
    fromRegister,
    userData,
    verifyLoading,
    verifyOtpHash,
    runRecaptcha,
    onRecaptchaFailure,
    onVerifyFailure
  });

  return (
    <>
      <Helmet>
        <meta name="referrer" content="no-referrer" />
      </Helmet>
      <AuthPageLayout
        title={translate("auth_otp-hash-page_title")}
        subtitle={translate("auth_otp-hash-page_subtitle")}
      >
        <Loader />
        <InvisibleReCaptcha ref={reCaptchaRef} />
      </AuthPageLayout>
    </>
  );
}

export default withLoginOtpHash(LoginOtpHash);
